var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#FC7753",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.174C11.7907 17.174 11.615 17.103 11.4731 16.9611C11.3312 16.8192 11.2605 16.6438 11.261 16.4349V12.7392H7.5653C7.35588 12.7392 7.18022 12.6683 7.03831 12.5263C6.89639 12.3844 6.82568 12.209 6.82617 12.0001C6.82617 11.7907 6.89713 11.615 7.03904 11.4731C7.18096 11.3312 7.35638 11.2605 7.5653 11.261H11.261V7.5653C11.261 7.35588 11.3319 7.18022 11.4738 7.03831C11.6157 6.89639 11.7912 6.82568 12.0001 6.82617C12.2095 6.82617 12.3852 6.89713 12.5271 7.03904C12.669 7.18096 12.7397 7.35638 12.7392 7.5653V11.261H16.4349C16.6443 11.261 16.82 11.3319 16.9619 11.4738C17.1038 11.6157 17.1745 11.7912 17.174 12.0001C17.174 12.2095 17.103 12.3852 16.9611 12.5271C16.8192 12.669 16.6438 12.7397 16.4349 12.7392H12.7392V16.4349C12.7392 16.6443 12.6683 16.82 12.5263 16.9619C12.3844 17.1038 12.209 17.1745 12.0001 17.174Z",
    fill: "#FC7753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRole);
export default __webpack_public_path__ + "static/media/add_role.70a6da0ffcbd515d9e51237acbb07270.svg";
export { ForwardRef as ReactComponent };